import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { AccordionAnimatedContent } from '../../../Accordion'
import { Divider } from '../../../Divider'
import Text from '../../../Text'

import { getInfoWidgetReadRows } from './ProfileInfoWidgetReadView.utils'

import * as styles from './ProfileInfoWidgetReadView.module.css'

function ProfileInfoWidgetReadView({
  config,
  data,
  isSectionsExpanded,
  onClickEmail,
}) {
  const { t } = useTranslation()

  const { baseRows, extraRows } = getInfoWidgetReadRows({
    config,
    data,
    t,
    onClickEmail,
  })

  const hasBaseRows = baseRows.length > 0

  return (
    <div className={styles.ProfileInfoWidgetReadView}>
      {hasBaseRows ? (
        baseRows.map(({ key, node }, index) => (
          <Fragment key={key}>
            {index > 0 ? <Divider className={styles.divider} /> : null}
            {node}
          </Fragment>
        ))
      ) : isSectionsExpanded ? null : (
        <Text isSecondary className={styles.empty}>
          {t('Widget.InfoNoFilledFieldsKey')}
        </Text>
      )}

      {extraRows.length > 0 ? (
        <AccordionAnimatedContent
          contentWrapperClassName={styles.extraSections}
          isOpen={isSectionsExpanded}
        >
          {extraRows.map(({ key, node }, index) => (
            <Fragment key={key}>
              {hasBaseRows || index > 0 ? (
                <Divider className={styles.divider} />
              ) : null}
              {node}
            </Fragment>
          ))}
        </AccordionAnimatedContent>
      ) : null}
    </div>
  )
}

export default ProfileInfoWidgetReadView
